import moment from "moment";
import { useForm } from "react-hook-form";

const defaultValues = {
  start_date: "",
  end_date: "",
  user_id: "",
};

export const serializeDateTime = (v) => {
  return v ? moment(v).format("YYYY/MM/DD HH:mm:ss") : null;
};
const useFilterForm = () => {
  return useForm({
    defaultValues,
  });
};

export default useFilterForm;
